module.exports = __webpack_public_path__ + "static/pinkbunnycomf-5b3e55c4bcbc65be32a39e5f32044800.jpeg";